/*
 * @Author: your name
 * @Date: 2021-11-16 15:21:35
 * @LastEditTime: 2021-11-26 16:03:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/utils/util.js
 */
import CryptoJs from 'crypto-js'
import {env} from './environment'
export function createRequestSign (url,time,version = '1.0.0') {
	let signKeyMap = {
		pre: '0026726213D5484BAD8A5EF13F6DEB28',
		publish: '0026726213D5484BAD8A5EF13F6DEB28',
		dev: 'FB8FA5F2A86546D785C9DFD7ECDC0D6F',
		daily: 'FB8FA5F2A86546D785C9DFD7ECDC0D6F',
	}
	let path = url.split('/').filter(v=>v!=='gateway').join('/')
	let signStr = `path${path}timestamp${time}version${version}${signKeyMap[env()]}`
	return CryptoJs.MD5(signStr).toString().toLocaleUpperCase()
}